import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { StreamingAccessCommand, StreamingHistoryResponse, StreamingSnapshot } from '@interfaces'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class TvStreamingService {
	private http = inject(HttpClient)

	getSnapshot(subscriberId: number): Observable<StreamingSnapshot> {
		return this.http.get<StreamingSnapshot>(`/subscribers/${subscriberId}/streaming`)
	}

	getHistory(subscriberId: number, page = 1, size = 6): Observable<StreamingHistoryResponse> {
		return this.http.get<StreamingHistoryResponse>(`/subscribers/${subscriberId}/streaming/history`, {
			params: { page, size }
		})
	}

	revoke(subscriberId: number, command: StreamingAccessCommand): Observable<StreamingSnapshot> {
		return this.http.post<StreamingSnapshot>(`/subscribers/${subscriberId}/streaming/revoke`, command)
	}

	resume(subscriberId: number, command: StreamingAccessCommand): Observable<StreamingSnapshot> {
		return this.http.post<StreamingSnapshot>(`/subscribers/${subscriberId}/streaming/resume`, command)
	}
	activateDevice(
		subscriberId: number,
		deviceId: string,
		command: StreamingAccessCommand
	): Observable<StreamingSnapshot> {
		return this.http.post<StreamingSnapshot>(
			`/subscribers/${subscriberId}/streaming/devices/${deviceId}/activate`,
			command
		)
	}

	deactivateDevice(
		subscriberId: number,
		deviceId: string,
		command: StreamingAccessCommand
	): Observable<StreamingSnapshot> {
		return this.http.post<StreamingSnapshot>(
			`/subscribers/${subscriberId}/streaming/devices/${deviceId}/deactivate`,
			command
		)
	}

	restoreDevice(
		subscriberId: number,
		deviceId: string,
		command: StreamingAccessCommand
	): Observable<StreamingSnapshot> {
		return this.http.post<StreamingSnapshot>(
			`/subscribers/${subscriberId}/streaming/devices/${deviceId}/restore`,
			command
		)
	}

	revokeDevice(subscriberId: number, deviceId: string, command: StreamingAccessCommand): Observable<StreamingSnapshot> {
		return this.http.post<StreamingSnapshot>(
			`/subscribers/${subscriberId}/streaming/devices/${deviceId}/revoke`,
			command
		)
	}
}
